import ChargeIdentityPartnerListView from '../../components/ChargeIdentityPartnerListView';

function ChargeIdentityPartnerListScreen() {
  return <ChargeIdentityPartnerListView showFullUI={true} />;
}

export default ChargeIdentityPartnerListScreen;
